import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import { State } from '../state.types';
import { Event, EventsState } from './events.types';
import { groupEventsByType } from './events.utils';
import NotificationsService from '../../services/NotificationsService/NotificationsService';

export const fetchEvents = createAsyncThunk(
  'events/fetch',
  NotificationsService.getEvents,
);

export const markEventAsSeen = createAsyncThunk(
  'events/markEventAsSeen',
  async (id: Event['id']) =>
    await NotificationsService.updateEvent({
      pathParams: { id },
      data: { seen: true },
    }),
);

const initialState: EventsState = {
  data: {},
};

const events = createSlice({
  name: 'events',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchEvents.fulfilled, (state, { payload }) => {
      const { events } = payload;

      state.data = {};

      events.forEach((event) => {
        state.data[event.id] = event;
      });
    });

    builder.addCase(markEventAsSeen.fulfilled, (state, { meta }) => {
      delete state.data[meta.arg];
    });
  },
});

const selectEvents = (state: State) => state.events.data;

export const selectEventsByType = createSelector(
  [selectEvents],
  groupEventsByType,
);

export default events.reducer;
